import { useState } from "react";
import { PersonLike } from "@lib/infrastructure";
import { MeetingRoom, useAppSelector, getIsOnlineMeetingLinkSupported } from "@lib/store";
import { Dispatch, SetStateAction } from "react";

export type AvailableRoomBookingState = {
  invitees: PersonLike[];
  isOnlineMeeting: boolean;
  message: string;
  setInvitees: Dispatch<SetStateAction<PersonLike[]>>;
  setIsOnlineMeeting: Dispatch<SetStateAction<boolean>>;
  setMessage: Dispatch<SetStateAction<string>>;
  setTitle: Dispatch<SetStateAction<string>>;
  title: string;
};

export const useAvailableRoomBookingState = (room: MeetingRoom): AvailableRoomBookingState => {
  const onlineMeetingLinkSupported = useAppSelector(getIsOnlineMeetingLinkSupported);
  const [invitees, setInvitees] = useState<PersonLike[]>([]);
  const [title, setTitle] = useState(room.displayName);
  const [message, setMessage] = useState("");
  const [isOnlineMeeting, setIsOnlineMeeting] = useState(onlineMeetingLinkSupported);

  return {
    invitees,
    isOnlineMeeting,
    message,
    setInvitees,
    setIsOnlineMeeting,
    setMessage,
    setTitle,
    title,
  };
};
